import { Alert } from '@components/display/alerts';
import { AlertTitle } from '@mui/material';

export interface IInfoToastProps {
    title?: string;
    msg?: string | string[];
}

export const InfoAlertToast = ({ msg, title = 'INFO' }: IInfoToastProps) => (
    <Alert.Info noStyle>
        <AlertTitle>{title}</AlertTitle>
        {msg}
    </Alert.Info>
);
